import { Card, CardContent } from '@mui/material';
import React from 'react';
import CustomLineChart from '../../../Charts/custom-line-chart';
import TableEmptyData from '../../../table/TableEmptyData';

export default function StockOverTime({ brands, stock_data, onBrandChange }) {
	// Convert all stock values to numbers, not strings
	const formattedData = stock_data && stock_data.length > 0
		? stock_data.map(item => ({
			date: item.date,
			value: typeof item.value === 'string' ? parseInt(item.value, 10) : Number(item.value || 0)
		}))
		: [];

	// Ensure proper sorting (oldest to newest)
	formattedData.sort((a, b) => {
		// Convert string dates to date objects for proper comparison
		const dateA = new Date(a.date);
		const dateB = new Date(b.date);
		return dateA - dateB;
	});

	// Make sure lineChartList uses the correct format
	const lineChartList = [
		{ dataKey: 'value', name: 'Stock Quantity', color: '#240B3B' },
	];

	return (
		<Card>
			<CardContent className="!p-0">
				<div className="flex justify-between items-center p-4 !pl-6">
					<div className="flex items-center">
						<span className="text-xl font-medium">
							Stock Over Time
						</span>
						<span className="bg-blue2 text-black1 px-2 rounded-xl ml-2 font-medium">
							{formattedData.length} days
						</span>
					</div>
				</div>
				{formattedData.length > 0 ? (
					<div className='pr-5 pb-4'>
						<CustomLineChart
							data={formattedData}
							dataKey="date"
							lineChartList={lineChartList}
							showLegend={true}
							height={300}
							showTooltip={true}
						/>
					</div>
				) : (
					<div className="border border-x-0 border-b-0 mb-10">
						<TableEmptyData content="stock history" />
					</div>
				)}
			</CardContent>
		</Card>
	);
}